import { menuArray } from "common/container/constants";

export default function RightSidebar({ color, setColor }) {
  const handleNavigate = (path, index, speed) => {
    setColor(index);
    const section = document.getElementById(speed);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <div
        className="fixed right-5 rounded-full top-1/2 -translate-y-1/2 bg-primary-color text-white  z-50 
             md:p-2 p-3 
             sm:top-auto sm:bottom-5 sm:right-2 sm:translate-y-0 sm:translate-x-0 sm:flex sm:flex-col"
        style={{
          position: "sticky", // For desktop screens
          top: "50%", // Centered vertically for larger screens
          transform: "translateY(-50%)", // Center adjustment
        }}
      >
        <nav className="flex flex-col gap-4">
          {menuArray.map((item, index) => (
            <button
              key={index}
              onClick={() => handleNavigate(item.path, index, item.speed)}
              className="text-white rounded-full justify-center items-center py-1 md:p-2 transition-colors"
            >
              <item.svg
                className={`${color === item.speed ? "white" : "#4A4A4A"}`}
              />
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}
